/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CatalogDto } from './CatalogDto';
import {
    CatalogDtoFromJSON,
    CatalogDtoFromJSONTyped,
    CatalogDtoToJSON,
    CatalogDtoToJSONTyped,
} from './CatalogDto';

/**
 * 
 * @export
 * @interface CatalogListResponse
 */
export interface CatalogListResponse {
    /**
     * 
     * @type {Array<CatalogDto>}
     * @memberof CatalogListResponse
     */
    data?: Array<CatalogDto>;
    /**
     * 
     * @type {number}
     * @memberof CatalogListResponse
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof CatalogListResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CatalogListResponse
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the CatalogListResponse interface.
 */
export function instanceOfCatalogListResponse(value: object): value is CatalogListResponse {
    return true;
}

export function CatalogListResponseFromJSON(json: any): CatalogListResponse {
    return CatalogListResponseFromJSONTyped(json, false);
}

export function CatalogListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CatalogListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(CatalogDtoFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function CatalogListResponseToJSON(json: any): CatalogListResponse {
    return CatalogListResponseToJSONTyped(json, false);
}

export function CatalogListResponseToJSONTyped(value?: CatalogListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(CatalogDtoToJSON)),
        'total': value['total'],
        'page': value['page'],
        'pageSize': value['pageSize'],
    };
}

